import {
  ANALYTICS_ASSETS_SEARCH,
  ANALYTICS_CAMPAIGNS_SEARCH,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS,
  ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS,
  ANALYTICS_DATA_EXPORT,
  ANALYTICS_INTENT_DATA,
  GET_ANALYTICS_ASSETS_FILTERS,
  GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST,
  GET_ANALYTICS_CAMPAIGNS_FILTERS,
  GET_ANALYTICS_WORKFLOW_FILTERS,
  ANALYTICS_WORKFLOWS_SEARCH,
  GET_ANALYTICS_WORKFLOW_LIST,
  ANALYTICS_DASHBOARD_WORKFLOW,
  ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS,
} from "constants/types";
import { storeLoading } from "modules/Campaigns/AssetsWithOutCampaigns/actions";
import { SelectOption } from "modules/Campaigns/interfaces";
import {
  getAnalyticsFilterId,
  getQueryCampaignId,
  getQueryEmailId,
  getQueryWorkflowId,
} from "modules/EmailBrowser/utils";
import { applyFiltersFromLocalStorage, moveSelectedFiltersToApplied } from "modules/Analytics/actions";
import {
  analyticsDashboardService,
  analyticsOverviewService,
  getAnalyticsCampaignsAssetsListService,
  getAnalyticsWorkflowListService,
  getAnalyticsGraphDataService,
  getAnalyticsSelectedCampaignsAssetsListService,
} from "modules/Services/AnalyticsService";
import store from "store";
import { getMonthDates, getQuarterDates, getDateObject } from "utils";
import { ANALYTICS_DEFAULT_DATES_FILTER } from "../Contacts/utils";
import { IAssetDropdownItem, IGraphData } from "../interfaces";
import {
  resetAllTabsFilter,
  serializeAnalyticsCampaigns,
  serializeAnalyticsEmails,
  getConstantCampaignEmailId,
  serializeAnalyticsWorkflow,
} from "../utils";

export const setFirstTimeAllDataShown = (flag: boolean) => {
  store.dispatch({
    type: ANALYTICS_CARD_DATA.SET_FIRST_ALL_DATA_SHOWN,
    payload: flag,
  });
};

export const getAnalyticsCardData = (params: any = {}) => {
  if (!params.exportAnalytics) storeLoading(ANALYTICS_CARD_DATA.LOAD);

  if (
    (params.startDate === undefined || params.startDate === "") &&
    (params.endDate === undefined || params.endDate === "")
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
    if (ANALYTICS_DEFAULT_DATES_FILTER.value === "qtr") {
      startDate = getQuarterDates().start_date;
      endDate = getQuarterDates().end_date;
    } else if (ANALYTICS_DEFAULT_DATES_FILTER.value === "month") {
      startDate = getMonthDates().start_date;
      endDate = getMonthDates().end_date;
    }
    params["startDate"] = startDate;
    params["endDate"] = endDate;
  }
  analyticsOverviewService(params)
    .then((response) => {
      if (response?.data?.success) {
        if (params.exportAnalytics) {
          store.dispatch({
            type: ANALYTICS_DATA_EXPORT.SET_OPEN,
            payload: response.data.email_address,
          });
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: false,
          });
        } else {
          store.dispatch({
            type: ANALYTICS_CARD_DATA.SUCCESS,
            payload: { ...response.data },
          });
          // check if every element in the object is 0
          const isEmpty = Object.keys(response.data.stats).every((key) => response.data.stats[key] === 0);
          store.dispatch({
            type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
            payload: isEmpty ? true : false,
          });
        }
        setFirstTimeAllDataShown(true);
      } else {
        store.dispatch({
          type: ANALYTICS_CARD_DATA.FAIL,
        });
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
          payload: true,
        });
      }
      // store.dispatch({ type: ANALYTICS_CARD_DATA.FILTER_RESET, payload: false });
    })
    .catch((err) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: ANALYTICS_CARD_DATA.FAIL,
        });
      }
      store.dispatch({
        type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
        payload: true,
      });
    });
};
export const getAnalyticsContentData = (params: any = {}, callback?: any) => {
  storeLoading(ANALYTICS_INTENT_DATA.LOAD);

  if (
    (params.startDate === undefined || params.startDate === "") &&
    (params.endDate === undefined || params.endDate === "")
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    params["startDate"] = startDate;
    params["endDate"] = endDate;
  }
  analyticsDashboardService(params)
    .then((response) => {
      if (response?.data?.success) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.SUCCESS,
          payload: { ...response.data },
        });
      } else {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.FAIL,
        });
      }
      if (callback)
        setTimeout(() => {
          callback(true);
        }, 500);
    })
    .catch((err) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: ANALYTICS_INTENT_DATA.FAIL,
        });
      }
    });
};

export const resetAnalyticsGraphData = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR,
  });
};

export const getAnalyticsCampaignsAssetsList = (allCampaigns?: boolean, useLocalStorageData?: boolean) => {
  getAnalyticsCampaignsAssetsListService()
    .then((response) => {
      if (response.data) {
        let { email_data, campaign_data, total_campaigns, total_emails, workflows: workflow_data } = response.data;
        let assets = serializeAnalyticsEmails(email_data);
        let campaigns = serializeAnalyticsCampaigns(campaign_data);
        let workflows = serializeAnalyticsWorkflow(workflow_data);
        store.dispatch({
          type: GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.SUCCESS,
          payload: { assets, campaigns, total_campaigns, total_emails, allCampaigns: allCampaigns },
        });
        store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: true });
        store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.SUCCESS, payload: workflows });
        const campaignId = getQueryCampaignId();
        const emailId = getQueryEmailId();
        if (campaignId && emailId) {
          let campaignAssets = assets.filter((asset) => asset.campaignId === campaignId);
          let filteredAsset = assets.find((asset) => asset.id === emailId);
          if (filteredAsset) {
            if (!allCampaigns) {
              updateFilterAssetList(campaignAssets); // added this action because some of the emails have no analytics
            }

            // due to which the default case doesn't trigger.
            // let assetDate = new Date(filteredAsset.dateTime).setHours(0, 0, 0, 0);
            // let dateObj = getQuarterDates();
            // let date = new Date(dateObj.start_date).setHours(0, 0, 0, 0);
            // if (assetDate < date) {
            //   store.dispatch({
            //     type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
            //     payload: { label: "All time", value: "all" },
            //   });
            // }
          }
          reorderCampaignsAndEmails();
        }
        reorderWorkflows();
        // console.log("useLocalStorageData: ", useLocalStorageData);
        if (useLocalStorageData) {
          console.log("applyFiltersFromLocalStorage Data: sdfksdfhkl");
          applyFiltersFromLocalStorage(JSON.parse(localStorage.getItem("analyticsFiltersWithId") || ""));
        }
      }
    })
    .catch((err) => {
      console.log("Analytics Error: ", err);
      store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: true });
    });
};
export const getAnalyticsSelectedCampaignsAssetsList = (campaignIds: string | any[] | undefined = []) => {
  getAnalyticsSelectedCampaignsAssetsListService(campaignIds)
    .then((response) => {
      if (response.data) {
        let { email_data } = response.data;
        let assets = serializeAnalyticsEmails(email_data);
        // let campaigns = serializeAnalyticsCampaigns(campaign_data);
        store.dispatch({
          type: GET_ANALYTICS_CAMPAIGNS_ASSETS_FILTERS_LIST.FILTER_EMAILS,
          payload: { assets: assets, campaignIds: campaignIds, campaign_id: campaignIds[campaignIds.length - 1] },
        });
      }
    })
    .catch((err) => {
      console.log("Analytics Error: ", err);
    });
};

export const setIsWorkflow = (flag: boolean) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_WORKFLOW.FIRST_TIME_SET,
    payload: flag,
  });
};

export const loadingAnalyticsWorkflowList = () => {
  store.dispatch({
    type: GET_ANALYTICS_WORKFLOW_LIST.LOAD,
  });
};

export const getAnalyticsWorkflowList = () => {
  loadingAnalyticsWorkflowList();
  getAnalyticsWorkflowListService()
    .then((response) => {
      if (response.data.success) {
        store.dispatch({
          type: GET_ANALYTICS_WORKFLOW_LIST.SUCCESS,
          payload: response.data,
        });
        let selectedWfIds = store.getState().analyticsDashboard.selectedWorkflowIds;
        if (selectedWfIds.length > 0) store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.REORDER });
      }
    })
    .catch((err) => {
      console.log("Analytics Error: ", err);
    });
};

// export const getDefaultCampaigns = (params?: any) => {
//   let additionalParams: any = {
//     analytic_request: "1",
//     allCampaigns: params.allCampaigns,
//   };
//   let startDate = store.getState().analyticsGraph.startDate;
//   let endDate = store.getState().analyticsGraph.endDate;
//   startDate = getQuarterDates().start_date;
//   endDate = getQuarterDates().end_date;
//   additionalParams["startDate"] = startDate;
//   additionalParams["endDate"] = endDate;
//   getAnalyticsGraphDataService(additionalParams)
//     .then((res: any) => {
//       const serializedData: IGraphData = res.data;
//       let campaignIds = serializedData?.campaigns_series?.map((campaign) => campaign?.campaign_id);
//       if (!additionalParams.campaignIds || additionalParams?.campaignIds?.length === 0) {
//         if (!additionalParams.allCampaigns) {
//           store.dispatch({
//             type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_DEFAULT,
//             payload: campaignIds,
//           });
//         }
//       }
//     })
//     .catch((err: any) => {
//       console.log(err);
//       store.dispatch({
//         type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL,
//         payload: {},
//       });
//       // show error alert on frontend
//     });
// };

export const getGraphData = (params?: any, callback?: any) => {
  let additionalParams: any = {
    analytic_request: "1",
    allCampaigns: params.allCampaigns,
  };
  if (
    params.campaignIds !== undefined &&
    params.campaignIds.length > 0 &&
    params.emailIds !== undefined &&
    params.emailIds.length > 0
  ) {
    additionalParams = {
      ...additionalParams,
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    };
  }
  if (params?.workflowIds?.length > 0) {
    additionalParams = {
      ...additionalParams,
      workflowIds: params.workflowIds,
      emailIds: params.emailIds,
    };
  }
  if (
    (params.startDate === undefined || params.startDate === "") &&
    (params.endDate === undefined || params.endDate === "")
  ) {
    let startDate = store.getState().analyticsGraph.startDate;
    let endDate = store.getState().analyticsGraph.endDate;
    analyticsDatesFilterChange({ value: "qtr", label: "1 QTR" });
    startDate = getQuarterDates().start_date;
    endDate = getQuarterDates().end_date;
    additionalParams["startDate"] = startDate;
    additionalParams["endDate"] = endDate;
  } else {
    additionalParams["startDate"] = params.startDate;
    additionalParams["endDate"] = params.endDate;
  }

  if (params.allCampaigns) {
    additionalParams["excludeCampaignsIds"] = params.excludeCampaignsIds;
    additionalParams["excludeAssetsIds"] = params.excludeAssetsIds;
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  getAnalyticsGraphDataService(additionalParams)
    .then((res: any) => {
      const serializedData: IGraphData = res.data;
      // let campaignIds = serializedData?.campaigns_series?.map((campaign) => campaign?.campaign_id);
      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_SUCCESS,
        payload: serializedData,
      });
      // if (!additionalParams.campaignIds || additionalParams?.campaignIds?.length === 0) {
      //   if (!additionalParams.allCampaigns) {
      //     store.dispatch({
      //       type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_DEFAULT,
      //       payload: campaignIds,
      //     });
      //   }
      // }
    })
    .catch((err: any) => {
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL,
          payload: {},
        });
      }
      // show error alert on frontend
    });
};

export const setCampaignsFilter = (filter: any, noReset?: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_FILTERS,
    payload: filter,
  });
  if (!noReset) {
    if (filter.isAllCampaigns !== undefined) resetAllTabsFilter(true);
    // console.log("setCampaignsFilter getAnalyticsCampaignsAssetsList[]", filter, noReset);
    getAnalyticsCampaignsAssetsList(filter.isAllCampaigns);
  }
};

export const resetAllTabsSelectedCampaignsAndEmailsAndGetList = () => {
  resetAllTabsFilter(true);
  resetSelectedCampaigns();
  resetSelectedEmails();
  // resetSelectedWorkflows();
  // console.log("resetAllTabsSelectedCampaignsAndEmailsAndGetList getAnalyticsCampaignsAssetsList[]");
  getAnalyticsCampaignsAssetsList();
  // store.dispatch({
  //   type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
  //   payload: true,
  // });
};

export const setShareProfileFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_SHARE_PROFILE_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const setDailyIqFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_DAILY_IQ_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const setWeeklyAccountInsightsFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WEEKLY_ACCOUNTS_INSIGHTS_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const toggleWorkflowFilter = (flag: boolean) => {
  store.dispatch({
    type: GET_ANALYTICS_CAMPAIGNS_FILTERS.SET_WORKFLOW_FILTER,
    payload: flag,
  });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
  if (flag === false) {
    resetSelectedWorkflows();
  }
};

export const resetShareProfileDailyIQandWeeklyAccountsFilter = () => {
  store.dispatch({ type: GET_ANALYTICS_CAMPAIGNS_FILTERS.RESET_CONSTANT_FILTERS });
  resetAllTabsSelectedCampaignsAndEmailsAndGetList();
};

export const reorderCampaignsAndEmails = () => {
  store.dispatch({ type: GET_ANALYTICS_CAMPAIGNS_FILTERS.REORDER_CAMPAIGNS });
  store.dispatch({ type: GET_ANALYTICS_ASSETS_FILTERS.REORDER_ASSETS });
};

export const reorderWorkflows = () => {
  store.dispatch({ type: GET_ANALYTICS_WORKFLOW_LIST.REORDER });
};

export const selectCampaign = (id: any, selectedCampaignsIds?: []) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET,
    payload: id,
  });
  // let ids: string | any[] | undefined = [];
  // if (selectedCampaignsIds) {
  //   let index = selectedCampaignsIds.find((x: any) => x === id) ?? -1;
  //   if (index > -1) {
  //     ids = selectedCampaignsIds.filter((x: any) => x !== id);
  //   } else {
  //     ids = [...selectedCampaignsIds, id];
  //   }
  // }
  // resetAllTabsFilter(true);
  // if (ids.length > 0 && ids.length <= 4) getAnalyticsSelectedCampaignsAssetsList(ids);
  // else if (ids.length <= 4) getAnalyticsCampaignsAssetsList();
};

// export const setSelectedCampaignAndEmailId = (campaignId: any, emailId: any) => {
//   store.dispatch({
//     type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_CAMPAIGN_AND_EMAIL,
//     payload: { campaignId, emailId },
//   });
// };

export const setWorkflowFilter = (filter: any) => {
  store.dispatch({
    type: GET_ANALYTICS_WORKFLOW_FILTERS.SET_FILTERS,
    payload: filter,
  });
};

export const setAssetsFilter = (filter: any) => {
  store.dispatch({
    type: GET_ANALYTICS_ASSETS_FILTERS.SET_FILTERS,
    payload: filter,
  });
};

export const setWorkflowAssetsFilter = (filter: any) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.FILTER_LIST,
    payload: filter,
  });
};
export const selectAsset = (asset_id: any, campaign_id: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SET,
    payload: { asset_id, campaign_id },
  });
};

export const selectWorkflowAsset = (asset_id: any, workflow_id: any) => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SET,
    payload: { asset_id, workflow_id },
  });
};

export const selectWorkflow = (id: number) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_WORKFLOW.SELECT,
    payload: id,
  });
};

export const setDefaultWorkflow = (workflowId: number) => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_WORKFLOW.SET, payload: workflowId });
  // Applied emails replaced with selected emails when going to Analytics from Workflow Detail Page
  moveSelectedFiltersToApplied();
};

export const resetSelectedWorkflows = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_WORKFLOW.RESET });
};

export const searchAnalyticsDropdownCampaigns = (name: string) => {
  store.dispatch({
    type: ANALYTICS_CAMPAIGNS_SEARCH.SET,
    payload: name,
  });
};

export const searchAnalyticsDropdownAssets = (name: string) => {
  if (name.trim() === "") {
    resetEmailSearch();
  } else {
    store.dispatch({
      type: ANALYTICS_ASSETS_SEARCH.SET,
      payload: name,
    });
  }
};

export const searchAnalyticsDropdownWorkflow = (name: string) => {
  if (name.trim() === "") {
    resetWorkflowSearch();
  } else {
    store.dispatch({
      type: ANALYTICS_WORKFLOWS_SEARCH.SET,
      payload: name,
    });
  }
};

// export const setGetDefaultData = () => {
//   store.dispatch({
//     type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.GET_DEFAULT_DATA,
//   });
// };

export const analyticsDatesFilterChange = (value: SelectOption) => {
  let isDefaultStateOfEmails = store.getState().analyticsDashboard.selectedAssetsIds.length === 0;
  // if (currentValue !== ANALYTICS_DEFAULT_DATES_FILTER.value) {
  //   setGetDefaultData();
  // }
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
    payload: value,
  });

  if (isDefaultStateOfEmails && value.label === "1 QTR" && value.value === "qtr")
    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES_OBJECT,
      payload: value,
    });
  let datesObject: any = getDateObject(value.value);

  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES,
    ...datesObject,
  });
  if (isDefaultStateOfEmails && value.label === "1 QTR" && value.value === "qtr") {
    store.dispatch({
      type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES,
      ...datesObject,
    });
  }
};

export const filterAction = (AllCampaignsFilterCheck: boolean, isFilterClicked?: boolean) => {
  let analyticsDashboard = store.getState().analyticsDashboard;
  let analyticsGraph = store.getState().analyticsGraph;
  let { selectedCampaignsIds, selectedAssetsIds } = analyticsDashboard;
  let { startDate, endDate } = analyticsGraph;
  let object: any = {
    allCampaigns: AllCampaignsFilterCheck,
    startDate: startDate,
    endDate: endDate,
  };
  if (selectedCampaignsIds.length > 0) {
    object["campaignIds"] = selectedCampaignsIds;
  }
  if (selectedAssetsIds.length > 0) {
    object["emailIds"] = selectedAssetsIds;
  }
  getAnalyticsFilteredGraphData(object);
  getAnalyticsCardData(object);
  getAnalyticsContentData(object);
};

export const getAnalyticsFilteredGraphData = (params: any) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD,
  });

  getAnalyticsGraphDataService({ ...params, analytic_request: "1" })
    .then((res: any) => {
      const serializedData: IGraphData = res.data;
      store.dispatch({
        type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_SUCCESS,
        payload: serializedData,
      });
    })
    .catch((err: any) => {
      console.log(err);
      if (!(err.message && err.message.includes("Operation canceled due to new request."))) {
        store.dispatch({
          type: ANALYTICS_DASHBOARD_GRAPH_DATA.LOAD_FAIL,
          payload: {},
        });
      }
      // show error alert on frontend
    });
};

export const closeAnalyticsExportPopup = () => {
  store.dispatch({ type: ANALYTICS_DATA_EXPORT.SET_CLOSE });
};

export const resetSelectedCampaigns = (isReset?: boolean) => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.RESET, payload: isReset });
};

export const resetSelectedEmails = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.RESET });
};

export const selectAllCampaigns = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD_SET_SELECTED_CAMPAINGS.SET_ALL });
};

export const resetEmailSearch = () => {
  store.dispatch({ type: ANALYTICS_ASSETS_SEARCH.RESET });
  store.dispatch({ type: GET_ANALYTICS_ASSETS_FILTERS.SET_FILTERS, payload: {} });
};

export const resetWorkflowSearch = () => {
  store.dispatch({ type: ANALYTICS_WORKFLOWS_SEARCH.RESET });
};

export const selectAllEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.SELECT_ALL,
  });
};

export const selectAllWorkflowEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.SELECT_ALL,
  });
};

export const unselectAllEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.UNSELECT_ALL,
  });
};

export const unselectAllWorkflowEmails = () => {
  resetAllTabsFilter(true);
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_WORKFLOW_ASSETS.UNSELECT_ALL,
  });
};

export const updateFirstTimeSearch = () => {
  store.dispatch({
    type: ANALYTICS_ASSETS_SEARCH.SET_FIRST_TIME,
  });
};

export const updateAssetListOnDateFilter = (value: SelectOption) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.DATE_FILTER,
    payload: value,
  });
};

export const updateFilterAssetList = (assets: IAssetDropdownItem[]) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_SELECTED_ASSETS.FILTER_LIST,
    payload: assets,
  });
};

export const resetDashboardCampaignFilters = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD.RESET_CAMPAIGN_FILTERS,
  });
};

export const getDashboardData = (firstRenderDone: boolean, callback?: any) => {
  const campaignId = getQueryCampaignId().toString();
  const emailId = getQueryEmailId().toString();
  const workflowId = getQueryWorkflowId();
  const fsId = getAnalyticsFilterId();
  let analyticsGraph = store.getState().analyticsGraph;
  let analyticsDashboard = store.getState().analyticsDashboard;
  let { startDate, endDate } = analyticsGraph;
  let {
    filterReset,
    selectedCampaignsIds,
    selectedAssetsIds,
    excludeCampaignsIds,
    excludeAssetsIds,
    appliedCampaignsFilters,
    selectedWorkflowsIds,
  } = analyticsDashboard;
  let stats = store.getState().analyticsGraph.data;
  const { isAllCampaigns, isShareProfile, isDailyIQ, isWeeklyAccountInsights } = appliedCampaignsFilters;

  let object: any = {
    allCampaigns: isAllCampaigns,
    startDate: startDate,
    endDate: endDate,
  };

  //Flow for first landing render
  if (
    ((campaignId !== "0" && emailId !== "0") || Object.keys(stats).length === 0 || filterReset === true) &&
    firstRenderDone === false
  ) {
    if (filterReset === true) {
      object = {
        campaignIds: selectedCampaignsIds,
        emailIds: selectedAssetsIds,
        ...object,
        ...(selectedWorkflowsIds?.length > 0
          ? {
              workflowIds: selectedWorkflowsIds,
            }
          : {}),
      };
    } else {
      if (!fsId) {
        analyticsDatesFilterChange(ANALYTICS_DEFAULT_DATES_FILTER);
        startDate = store.getState().analyticsGraph.startDate;
        endDate = store.getState().analyticsGraph.endDate;
        if (selectedCampaignsIds.length <= 0 && campaignId !== "0") {
          selectAsset(parseInt(emailId), parseInt(campaignId));
          moveSelectedFiltersToApplied();
        }
        if (campaignId !== "0" && emailId !== "0") {
          object["campaignIds"] = [campaignId];
          object["emailIds"] = [emailId];
        }
        if (selectedWorkflowsIds?.length > 0) {
          object["workflowIds"] = selectedWorkflowsIds;
        } else if (workflowId) {
          object["workflowIds"] = [workflowId];
        }
      }
    }

    // check if is share profile || daily IQ || weekly accounts insights
    if (isShareProfile || isDailyIQ || isWeeklyAccountInsights) {
      let campaign_email_id = getConstantCampaignEmailId({
        isShareProfile,
        isDailyIQ,
        isWeeklyAccountInsights,
      });
      object["campaignIds"] = [campaign_email_id];
      object["emailIds"] = [campaign_email_id];
    }

    if (isAllCampaigns) {
      object["excludeCampaignsIds"] = excludeCampaignsIds;
      object["excludeAssetsIds"] = excludeAssetsIds;
    }

    // console.log("getDashboardData getAnalyticsCampaignsAssetsList", object);
    // getAnalyticsCampaignsAssetsList();
    getGraphData(object);
    getAnalyticsCardData(object);
    getAnalyticsContentData(object, callback);
  }
};

export const setDefaultFlag = () => {
  store.dispatch({ type: ANALYTICS_DASHBOARD.SET_DEFAULT_FLAG });
};

export const setRenderDone = () => {
  store.dispatch({ type: ANALYTICS_CARD_DATA.RENDER_DONE, payload: false });
};
